"use client"

import React from "react";
import { useTranslations } from "next-intl";
import cn from "classnames";
import {
    Flex,
    Spin
} from "antd";
import dayjs from "dayjs";
import dynamic from "next/dynamic";
import utc from 'dayjs/plugin/utc';
import style from "./userCountries.module.scss";
import {
    Card,
} from "@/theme/ui";
import {
    useApi,
    useTempData
} from "@/lib/hook";
import { PopoverDatePreset } from "@/theme/ui/datePicker/customPicker";

dayjs.extend(utc);

const Line = dynamic(() => import('@ant-design/plots').then(({ Line }) => Line),
    { ssr: false }
);

const initFilterData = {
    start: dayjs().utc().locale('uk').startOf('week').toDate(),
    end: dayjs().utc().locale('uk').endOf('week').toDate(),
    key: 'week'
}

export const UserCountries = () => {
    const t = useTranslations('reports.user_countries');
    const {data: tempData, setTempData} = useTempData('user_countries', initFilterData);
    const { data: data, isFetching } = useApi({
        route: {
            name: 'reports.users',
        },
        data: {...tempData},
        setting: {
            select: (resp) => resp,
        },
    });

    const changeDate = (value, key) => {
        setTempData({
            start: value.start,
            end: value.end,
            key: key
        })
    }

    const config = {
        data: data?.data ?? [],
        xField: 'date',
        yField: 'count',
        colorField: t('new_users'),
        scale: { color: { range: ['#C95F5F', '#9B2525', '#9A5151'] } },
        height: 345,
        maxWidth: 910,
        style: {
            lineWidth: 2,
        },
    };

    return (
        <>
            <div className={cn(style.block, 'support_block')}>
                <Card
                    className={'charts'}
                >
                    <Spin spinning={isFetching}>
                        <Flex
                            justify={'space-between'}
                            align={'center'}
                            style={{
                                marginBottom: '20px'
                            }}
                            wrap={'wrap'}
                            gap={20}
                        >
                            <div
                                className={style.title}
                            >
                                {t('new_users')}
                            </div>
                            <Flex
                                align={'center'}
                                gap={20}
                                wrap={'wrap'}
                            >
                                <div>{t('period')} {data?.total ?? 0} {t('users')}</div>
                                <PopoverDatePreset
                                    onChange={changeDate}
                                    initData={initFilterData.key}
                                    date={tempData}
                                />
                            </Flex>
                        </Flex>
                        {!isFetching && data?.data?.length > 0 ? (
                            <Line {...config} />
                        ) : (
                            <div style={{ textAlign: 'center', paddingTop: 100 }}>{t('no_data')}</div>
                        )}
                    </Spin>
                </Card>
            </div>
        </>
    );
}